/**
 * The bound on ONE dictated take, shared by the browser that records it and
 * the route that buys the transcript.
 *
 * 🔴 It exists because the two disagreed. The recorder allowed forty minutes
 * and set no bitrate, so a browser whose MediaRecorder defaults high (Safari
 * records `audio/mp4` AAC) could produce a file the route refuses - and the
 * refusal was a bare `invalid_request`, which the recorder renders as "we are
 * holding the recording, send it again". A resend of the same bytes can never
 * be accepted, so the reader is invited into a loop with no exit.
 *
 * Both sides read this file now: the recorder keeps a take under the cap and
 * says so when it stops, and the route names the refusal when one arrives
 * anyway (an older bundle, a hand-built request).
 */

/** The largest take the transcription route accepts, in bytes. */
export const TRANSCRIBE_MAX_BYTES = 25 * 1024 * 1024;

/**
 * What the recorder asks its encoder for. Speech at 32 kbps is comfortably
 * intelligible for transcription in every codec a browser offers here, and it
 * puts a forty-minute take at about 9.6 MB - well inside the cap on any
 * browser, whatever its own default would have been.
 */
export const TRANSCRIBE_BITS_PER_SECOND = 32_000;

/**
 * The size at which a take is stopped rather than allowed to grow into a
 * refusal. Below the cap by a margin, because the encoder flushes in chunks
 * and the container adds its own bytes on close.
 */
export const TRANSCRIBE_STOP_BYTES = Math.floor(TRANSCRIBE_MAX_BYTES * 0.9);
